import { render, staticRenderFns } from "./SpinWin2.vue?vue&type=template&id=170f5d72&scoped=true&"
import script from "./SpinWin2.vue?vue&type=script&lang=js&"
export * from "./SpinWin2.vue?vue&type=script&lang=js&"
import style0 from "./SpinWin2.vue?vue&type=style&index=0&id=170f5d72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170f5d72",
  null
  
)

export default component.exports